module.exports = __webpack_public_path__ + "img/金燕.15844163.png";